import { render, staticRenderFns } from "./future.vue?vue&type=template&id=7ffee570&scoped=true"
import script from "./future.vue?vue&type=script&lang=js"
export * from "./future.vue?vue&type=script&lang=js"
import style0 from "./future.vue?vue&type=style&index=0&id=7ffee570&prod&lang=scss"
import style1 from "./future.vue?vue&type=style&index=1&id=7ffee570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffee570",
  null
  
)

export default component.exports